import { useTranslation } from 'next-i18next';
import React from 'react';
import ContentLoader from 'react-content-loader';

const SinglePageDescriptionLoader = props => {
  const { t } = useTranslation();

  const loading = t('loading');

  return (
    <ContentLoader
      speed={2}
      viewBox="0 0 362 625"
      primarycolor="#f3f3f3"
      secondarycolor="#ecebeb"
      aria-label={loading}
      title={loading}
      uniqueKey="singlePageDescriptionLoader"
      {...props}
    >
      <rect x="5" y="5" rx="4" ry="4" width="150" height="25" />
      <rect x="5" y="46" rx="0" ry="0" width="359" height="88" />
      <rect x="5" y="160" rx="0" ry="0" width="174" height="48" />
      <rect x="184" y="160" rx="0" ry="0" width="174" height="48" />
      <rect x="5" y="234" rx="0" ry="0" width="359" height="119" />
      <rect x="5" y="368" rx="0" ry="0" width="359" height="190" />
      <rect x="5" y="573" rx="0" ry="0" width="359" height="70" />
    </ContentLoader>
  );
};

export default SinglePageDescriptionLoader;
